module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-2021-1.a4733b66.jpg";